<div class="school-info-panel__grid">
  <div class="school-info-panel__item">
    <span class="school-info-panel__section-title">School Information</span>
    <div>
      <div class="school-info-panel__address-item">
        <span class="school-info-panel__label">Address: </span>
      </div>
      <div class="school-info-panel__value">
        <span [innerHTML]="getAddressWithLineBreaks(schoolData.address) || '-'"> </span>
      </div>
      <div class="mt-2">
        <span class="school-info-panel__label">County: </span>
      </div>
      <div class="school-info-panel__value">
        <span>
          {{ county !== '-' ? county : '-' }}
        </span>
      </div>
      <div class="mt-2">
        <span class="school-info-panel__label">School Type: </span>
      </div>
      <div class="school-info-panel__value">
        <span>{{ schoolData.schoolType || '-' }}</span>
      </div>
      <div class="mt-2">
        <span class="school-info-panel__label">Fiscal Year End Date: </span>
      </div>
      <div class="school-info-panel__value">
        <span>
          {{ schoolData.fiscalYearEndDate ? (schoolData.fiscalYearEndDate | date: 'MMMM d') || '-' : '-' }}
        </span>
      </div>
    </div>
  </div>
  <div class="school-info-panel__item">
    <span class="school-info-panel__section-title">HDMA Information</span>
    <div>
      @if (schoolData.hdmaName) {
        <div class="school-info-panel__address-item">
          <span class="school-info-panel__label">HDMA Name: </span>
        </div>
        <div class="school-info-panel__value">
          <span>{{ schoolData.hdmaName || '-' }}</span>
        </div>
      }
      <div class="school-info-panel__address-item">
        <span class="school-info-panel__label">Email: </span>
      </div>
      <div class="school-info-panel__value">
        <span>{{ schoolData.hdmaEmail || schoolData.email || '-' }}</span>
      </div>
      <div class="school-info-panel__address-item">
        <span class="school-info-panel__label">Phone: </span>
      </div>
      <div class="school-info-panel__value">
        <span>{{ formattedPhone }}</span>
      </div>
      @if (schoolData.backgroundCheckValidationDate) {
        <div class="school-info-panel__address-item">
          <span class="school-info-panel__label">Background Check Validated: </span>
        </div>
        <div class="school-info-panel__value">
          <span>
            {{
              schoolData.backgroundCheckValidationDate
                ? (schoolData.backgroundCheckValidationDate | date: 'MM/dd/yyyy') || '-'
                : '-'
            }}
          </span>
        </div>
      }
    </div>
  </div>
  <div class="school-info-panel__item">
    <span class="school-info-panel__section-title">Other Details</span>
    <div>
      <div class="school-info-panel__address-item">
        <span class="school-info-panel__label">FEIN Number: </span>
      </div>
      <div class="school-info-panel__value">
        <span>{{ schoolData.feinNumber || '-' }}</span>
      </div>
      <div class="school-info-panel__address-item">
        <span class="school-info-panel__label">DNPE: </span>
      </div>
      <div class="school-info-panel__value">
        <span>{{ schoolData.dnpeNumber || '-' }}</span>
      </div>
    </div>
  </div>
  <div class="school-info-panel__grey-item">
    <span class="school-info-panel__sub-title">School ID</span>
    <span class="school-info-panel__label text-wrap">{{ schoolData.schoolId || '-' }}</span>
  </div>
  <div class="school-info-panel__grey-item">
    <span class="school-info-panel__sub-title">{{
      schoolData.directorName ? "Director's Name" : 'Aid Program Eligibility'
    }}</span>
    <span class="school-info-panel__label text-wrap">{{
      schoolData.directorName || schoolData.aidProgramEligibility?.join(', ') || '-'
    }}</span>
  </div>
  <div class="school-info-panel__grey-item">
    <span class="school-info-panel__sub-title">Education Delivery Method</span>
    <span class="school-info-panel__label text-wrap">{{ schoolData.educationDeliveryMethod || '-' }}</span>
  </div>
</div>
